









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {SaraivaCnpjDisponivel} from '@/model/resource/SaraivaCnpjDisponivel'
import {InputSaraivaCnpjDisponivelSchema} from '@/schema/resource/SaraivaCnpjDisponivel/InputSaraivaCnpjDisponivelSchema'

@Component
export default class PersistSaraivaCnpjDisponivelView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputSaraivaCnpjDisponivelSchema()
  saraivaCnpjDisponivel = new SaraivaCnpjDisponivel()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.saraivaCnpjDisponivel.getSaraivaCnpjDisponivel(id)
    }

    $.await.done('getSaraivaCnpjDisponivel')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.saraivaCnpjDisponivel.persistSaraivaCnpjDisponivel()
    await Helper.successAndPush(
      'system.success.persist',
      '/saraiva-cnpj-disponivel/list'
    )
  }
}
